/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

var TYPE_MAP = {
	"metawear": "activity",
	"a&dweight": "weight",
	"a&dbloodpressure": "bloodpressure",
	"biosbloodpressure": "bloodpressure",
	"nonin": "spo2",
	"foratng": "bloodsugar",
	"forair20": "bodytemperature",
	"ihbloodpressure": "bloodpressure",
	"ihweight": "weight",
	"foraspo2": "spo2",
	"ihspo2": "spo2"
};

module.exports = Model({
	name: "owndevices",
	init: init,
	triggers: triggers,
	listeners: listeners,

	refresh: refresh,
	processList: processList,
	errorExists: errorExists
});

function init() {
	this._list = [];
	this._removing = false;
	this._updating = false;
	this.push({
		list: [],
		updating: null,
		removing: null
	});
	this.refresh();
}

function triggers() {
	return {
		"view": view,
		"cancel": cancel,

		"add:start": addStart,
		"add:submit": addFinish,

		"remove:start": removeStart,
		"remove:submit": removeFinish,
		"remove:cancel": removeCancel,

		"update:start": updateStart,
		"update:submit": updateFinish,
	};
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"mqtt:$/devices/added": handle_device_add,
		"mqtt:$/devices/updated": handle_device_update,
		"mqtt:$/devices/removed": handle_device_remove,
		"mqtt:$/devices/battery/updated": handle_device_battery_update
	};
}

function view(){
	this.emit("bluetooth:trigger:initialize");
	this.dispatch("viewing");
	this.emit("usermetrics:trigger:track", "view own bluetooth devices");
}

function refresh(){
	this.emit("save:trigger:start");
	return this.api.devices.list()
		.then(processList.bind(this))
		.catch(handle_error.bind(this));
}

function processList(list){
	var sortedList = list.sort(sortByBattery);
	this.emit("save:trigger:finish");
	this._list = sortedList;
	this.extend({
		list: sortedList
	});
}

function handle_device_add(device){
	var current = this._list;
	var newList = current.concat(device);
	this.processList(newList);
}

function handle_device_update(device){
	var device_id = device._id;
	var current = this._list;
	var newList = current.map(function(ele){
		if(ele._id === device_id)
			return xtend(ele, device);
		return ele;
	});
	this.processList(newList);
}

function handle_device_remove(device){
	var current = this._list;
	var newList = current.filter(function(ele){
		return ele._id !== device;
	});
	this.processList(newList);
}

function handle_device_battery_update(data){
	var device_id = data.device;
	var batteryLevel = data.battery;

	var current = this._list;
	var newList = current.map(function(ele){
		if(ele._id === device_id)
			return xtend(ele, {
				battery_level: batteryLevel
			});
		return ele;
	});
	this.processList(newList);
}

function addStart(){
	this.dispatch("adding");
	this.emit("usermetrics:trigger:track", "begin adding new bluetooth device to own devices");
}

function addFinish(data){
	var device = xtend(data, {
		device_type: TYPE_MAP[data.model]
	});

	var list = this._list;
	var checkExists = checkMacExists(list, device);
	if(checkExists) {
		this.emit("usermetrics:trigger:track", "attempt to add bluetooth device to own devices but mac already exists");
		return this.errorExists();
	}

	this.emit("usermetrics:trigger:track", "add new bluetooth device to own devices");
	return this.api.devices.add(device)
		.then(finish.bind(this));
}

function removeStart(data){
	this._removing = data.device;
	this.extend({
		removing: data.device
	});
	this.dispatch("removing");
	this.emit("usermetrics:trigger:track", "open remove own bluetooth device popup");
}

function removeFinish(){
	var removing = this._removing;
	this.emit("usermetrics:trigger:track", "remove own bluetooth device");
	return this.api.devices.remove(removing)
		.then(finish.bind(this));
}

function updateStart(data){
	this._updating = data.device;
	this.extend({
		updating: data.device
	});
	this.dispatch("updating");
	this.emit("usermetrics:trigger:track", "begin updating own bluetooth device");
}

function updateFinish(data){
	var updating = this._updating;
	var device = xtend(updating, xtend(data, {
		device_type: TYPE_MAP[data.model]
	}));

	var list = this._list;
	var checkExists = checkMacExists(list, device);
	if(checkExists) {
		this.emit("usermetrics:trigger:track", "attempt to update own bluetooth device but mac already exists");
		return this.errorExists();
	}

	this.emit("usermetrics:trigger:track", "update own bluetooth device");
	return this.api.devices.update(device)
		.then(finish.bind(this));
}

function cancel(){
	if(!this._didUpdate){
		if(!this._updating) this.emit("usermetrics:trigger:track", "cancel add new bluetooth device to own devices");
		else this.emit("usermetrics:trigger:track", "cancel update bluetooth device to own devices");
	} 
	this._updating = null;
	this._removing = null;
	this._didUpdate = null;
	this.extend({
		updating: null,
		removing: null,
		didUpdate: null
	});
}


function removeCancel(){
	this._removing = false;
	this.extend({
		removing: null
	});
	this.emit("usermetrics:trigger:track", "cancel remove own bluetooth device");
}

function finish(){
	this.dispatch("finished");
	this._didUpdate = true;
}

function handle_error(){
	this.emit("save:trigger:finish");
}

function checkMacExists(devices, device){
	return devices.reduce(function(acc, dev){
		if(dev.mac === device.mac && dev._id !== device._id) acc = true;
		return acc;
	}, false);
}

function errorExists(){
	this.emit("toast:trigger:show", {
		content: "devices.errorexists",
		style: "error"
	});
}

function sortByBattery(a, b){
	if(a.battery_level === 0) return 1;
	if(b.battery_level === 0) return -1;
	return a.battery_level - b.battery_level;
}